import React, {useContext} from 'react';
import {useParams} from "react-router-dom";
import OrganizationListPageTemplate from "../../../components/Templates/OrganizationListPageTemplate";
import {AuthContext} from "../../../context/AuthContext";

function OrgMedCenterList(props) {
    const {medId, orgName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const userId = useContext(AuthContext)?.token?.userId

    return (
        <OrganizationListPageTemplate
            getOrgListAPI={`/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations?`}
            roleIs={3}
            addOrgAPI={`/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations`}
            breadCrumbsItems={[
                {title: 'Контрагенты'},
                {title: orgName, actual: true},
            ]}/>
    );
}

export default OrgMedCenterList;
